import { ActionContext, ActionTree } from 'vuex'
import { RMA } from '@one/types'
import { AxiosPromise, AxiosResponse } from 'axios'
import { RootState } from '../index'
import { mt } from './mutations'
import { RMAState } from './types'

export const actions: ActionTree<RMAState, RootState> = {
  fetchComplaintForm({ commit }: ActionContext<RMAState, RootState>) {
    return this.$api.rma.app
      .getComplaintForm()
      .then(
        ({
          data,
        }: AxiosResponse<RMA.App.Response.PreparedComplaintForm>) => {
          commit(mt.SET_IS_CREATION_FROM_GIN_ENABLED, data.isCreationFromGoodIssuedNotesEnabled)
          commit(mt.SET_COMPLAINT_REASONS, data)
          return Promise.resolve(data)
        },
      )
  },

  createRMA(_, data: RMA.App.Request.ComplaintFormDto) {
    return this.$api.rma.app.createComplaint(data).then(
      (res: any): AxiosPromise<void> => {
        return Promise.resolve(res)
      },
    )
  },

  fetchComplaintsList({
    state,
    commit,
  }: ActionContext<RMAState, RootState>) {
    const {
      pageNumber,
      pageSize,
    }: RMA.App.Response.PagerComplaintDto = state.complaintsList

    return this.$api.rma.app
      .getComplaints(pageNumber, pageSize)
      .then(
        ({ data }: AxiosResponse<RMA.App.Response.PagerComplaintDto>) => {
          const complaintsIds = data.items.map(
            (orders: RMA.App.Response.ComplaintDto) => orders.id,
          )
          commit(mt.SET_PAGINATED_COMPLAINTS, complaintsIds)
          commit(mt.SET_COMPLAINTS, data.items)
          commit(mt.SET_COMPLAINTS_TOTAL, data.totalItems)
          commit(mt.SET_COMPLAINT_STATUS_VISIBLE, data.showStatusColumn)
          return Promise.resolve(data)
        },
      )
  },

  fetchSingleComplaint(
    { commit }: ActionContext<RMAState, RootState>,
    complaintId: string,
  ) {
    return this.$api.rma.app
      .getComplaint(complaintId)
      .then(({ data }: AxiosResponse<RMA.App.Response.ComplaintDto>) => {
        commit(mt.SET_COMPLAINT_DETAIL, data)
        commit(mt.SET_COMPLAINTS, [data])
        return Promise.resolve(data)
      })
  },

  changePageComplaints(
    { commit, dispatch }: ActionContext<RMAState, RootState>,
    page: number,
  ) {
    commit(mt.SET_PAGE_COMPLAINTS, page)
    return dispatch('fetchComplaintsList')
  },
}
export default actions
